import { regexTitle } from 'src/app/utils/validations';
import * as yup from 'yup';

export const schema = yup.object().shape({
  name: yup
    .string()
    .matches(regexTitle, 'El nombre no es válido.')
    .required('El nombre es obligatorio.'),
  status: yup.boolean(),
  description: yup.string(),
});

export const defaultValues = {
  name: '',
  description: '',
  modelName: '',
  deviceId: '',
  brand: '',
  features: [],
  company_key: '',
  location_key: '',
  status: true,
};
